import {
  ResourcesPage,
  ResourceByIdPage,
  TopicsPage,
  TopicDetailPage
} from '@BUP/pages';
import {
  useRouteMatch,
  Switch
} from 'react-router-dom';
import { RoleRoute } from '@BUP/routes';


const ResourcesNavigation = () => {
  const match = useRouteMatch();

  return (
    <Switch>
      <RoleRoute
        name="ResourcesPage" 
        component={ResourcesPage} 
        path={'/resources'} 
        exact 
      />
      <RoleRoute 
        name="ResourcesByIdPage"
        component={ResourceByIdPage} 
        path={`${match.path}/:resourceId`} 
        exact 
      />
      <RoleRoute
        name="TopicsPage" 
        component={TopicsPage} 
        path={`${match.path}/:resourceId/level/:levelId`} 
        exact 
      />
      <RoleRoute 
        name="TopicDetailPage"
        component={TopicDetailPage} 
        path={`${match.path}/:resourceId/level/:levelId/topic/:topicId`} 
        exact 
      />
    </Switch>
  )
}

export default ResourcesNavigation;